export default __webpack_public_path__ + "static/media/filter_active.3eeac41b.svg";